import { ModifierCard } from '../atoms/ModifierCard';

/**
 * WorldModifierOverlay — shown when a boss-kill threshold is crossed (every 4 bosses).
 *
 * Presents 3 modifier cards ordered light → heavy (common first, legendary last).
 * Each card shows the active debuffs and the run-long reward bonuses.
 * Choosing a modifier REPLACES the current active modifier (debuffs do not stack).
 *
 * Props:
 *   modifiers  — array of modifier objects from generateModifierCombinations()
 *   onChoose   — (modifierObj) → void
 */
export function WorldModifierOverlay({ modifiers, onChoose }) {
  return (
    <div className="modifier-overlay">
      <h2 className="modifier-title">⚠️ World Modifier</h2>
      <p className="modifier-sub">
        A boss has fallen — the world shifts. Accept a curse in exchange for greater rewards.
      </p>

      <div className="modifier-choices">
        {modifiers.map(mod => (
          <ModifierCard key={mod.rarity} mod={mod} onChoose={() => onChoose(mod)} />
        ))}
      </div>
    </div>
  );
}
